import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export const api = axios.create({ baseURL: API_BASE });

// Helper to read current UI language
export const getCurrentLang = (): string => {
  const lang = localStorage.getItem('lang');
  if (lang === 'ky' || lang === 'en') return lang;
  return 'ru';
};

// Global interceptor: append ?lang= to all GET requests that hit our API (except admin pages)
axios.interceptors.request.use(config => {
  if (config.method === 'get' && config.url?.startsWith(API_BASE)) {
    // Skip for admin pages - admin should see all data regardless of language
    const isAdminPage = window.location.pathname.startsWith('/admin');
    // Skip binary/media endpoints where lang is irrelevant
    const isBinaryEndpoint =
      config.url.includes('/media/') ||
      config.url.includes('/download/') ||
      config.url.includes('/get-image/') ||
      config.url.includes('/get-images/') ||
      config.url.includes('/news/media/');

    if (!isAdminPage && !isBinaryEndpoint) {
      const lang = getCurrentLang();
      config.params = { ...config.params, lang };
    }
  }
  return config;
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const isAdminPage = () => window.location.pathname.startsWith('/admin');

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && isAdminPage()) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      return Promise.reject(err);
    }
    // На публичных страницах не бросаем в overlay — просто тихо игнорируем
    return Promise.resolve({ data: null });
  }
);
